import React from 'react';
import { Link } from 'react-router-dom';
import { UserCheck, DoorOpen, Package, Activity, Users } from 'lucide-react';

const REPORTS = [
  {
    to: '/reports/visitor-gate-passes',
    icon: UserCheck,
    title: 'Visitor Gate Passes',
    description: 'All visitor gate passes generated via the approval flow. Filter by visitor type, status, and date range.',
    accent: 'bg-blue-100 text-blue-600',
  },
  {
    to: '/reports/employee-gate-passes',
    icon: DoorOpen,
    title: 'Employee Gate Passes',
    description: 'Official and personal exit passes. Filter by department, supervisor, type, and status.',
    accent: 'bg-orange-100 text-orange-600',
  },
  {
    to: '/reports/items',
    icon: Package,
    title: 'Items Report',
    description: 'All item passes — returnable and non-returnable goods. Track overdue returns and vendor details.',
    accent: 'bg-purple-100 text-purple-600',
  },
  {
    to: '/reports/employee-movement',
    icon: Activity,
    title: 'Employee Movement',
    description: 'Daily movement log per employee — first entry, last exit, and pass types used. Single-day view.',
    accent: 'bg-emerald-100 text-emerald-600',
  },
  {
    to: '/reports/candidates',
    icon: Users,
    title: 'Candidate Visits',
    description: 'All candidate interviews registered at the gate. Filter by status and interviewing employee.',
    accent: 'bg-yellow-100 text-yellow-600',
  },
];

export default function Reports() {
  return (
    <div className="space-y-6 fade-up">
      <header>
        <div className="overline">Module 07</div>
        <h1 className="heading text-3xl font-black text-ink">Reports</h1>
        <p className="text-sm text-zinc-500 mt-1">
          Admin-only operational reports with server-side filtering, sorting, and export.
        </p>
      </header>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {REPORTS.map(r => {
          const Icon = r.icon;
          return (
            <Link key={r.to} to={r.to}
              className="card p-5 flex flex-col gap-3 hover:shadow-md transition-shadow group">
              <div className={`w-10 h-10 rounded-lg flex items-center justify-center ${r.accent}`}>
                <Icon size={20} />
              </div>
              <div className="flex-1">
                <h2 className="font-bold text-ink text-base group-hover:text-primary transition-colors">{r.title}</h2>
                <p className="text-sm text-zinc-500 mt-1 leading-relaxed">{r.description}</p>
              </div>
              <div className="text-xs font-semibold text-primary">Open Report →</div>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
